export default __webpack_public_path__ + "static/media/pietrosignature.b1ea35d2.jpg";